import React from "react";
import "./Index.css";

const Index = () => {
  return (
    <div className="loader-container">
      <div className="loader">Loading...</div>
    </div>
  );
};

export default Index;
